import { render, staticRenderFns } from "./AdvancedCustomerHistory.vue?vue&type=template&id=56e3a556&"
import script from "./AdvancedCustomerHistory.vue?vue&type=script&lang=js&"
export * from "./AdvancedCustomerHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports